var map = {
	"./ar.json": [
		2296,
		0
	],
	"./de.json": [
		2297,
		1
	],
	"./en.json": [
		809
	],
	"./es.json": [
		2298,
		2
	],
	"./fr.json": [
		2299,
		3
	],
	"./id.json": [
		2300,
		4
	],
	"./it.json": [
		2301,
		5
	],
	"./ja.json": [
		2302,
		6
	],
	"./no.json": [
		2303,
		7
	],
	"./pt-br.json": [
		2304,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1228;
module.exports = webpackAsyncContext;